import { SEO, orgJsonLd, websiteJsonLd } from "@/components/SEO";
import { useSite } from "@/context/SiteContext";
import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/home/Marquee";
import { Positioning } from "@/components/home/Positioning";
import { WhyUs } from "@/components/home/WhyUs";
import { ServicesPreview } from "@/components/home/ServicesPreview";
import { WebDevHighlight } from "@/components/home/WebDevHighlight";
import { Checklist } from "@/components/home/Checklist";
import { Process } from "@/components/home/Process";
import { AuditCTA } from "@/components/home/AuditCTA";
import { PortfolioPreview } from "@/components/home/PortfolioPreview";
import { Testimonials } from "@/components/home/Testimonials";
import { PricingPreview } from "@/components/home/PricingPreview";
import { BlogPreview } from "@/components/home/BlogPreview";
import { FinalCTA } from "@/components/home/FinalCTA";

export default function Home() {
  const site = useSite();
  const jsonLd = [
    orgJsonLd(site),
    websiteJsonLd(site),
    {
      "@context": "https://schema.org",
      "@type": "Service",
      serviceType: "Search Engine Optimization",
      provider: { "@type": "ProfessionalService", name: site.brand, url: site.domain },
      areaServed: "IN",
      description: "Technical SEO, on-page SEO, content SEO, local SEO, e-commerce SEO, link building and SEO audits.",
    },
  ];

  return (
    <>
      <SEO page="home" path="/" jsonLd={jsonLd} />
      <Hero />
      <Marquee />
      <Positioning />
      <WhyUs />
      <ServicesPreview />
      <WebDevHighlight />
      <Checklist />
      <Process />
      <AuditCTA />
      <PortfolioPreview />
      <Testimonials />
      <PricingPreview />
      <BlogPreview />
      <FinalCTA />
    </>
  );
}
